<template>
  <div v-if="show" class="popup-container" @click.self="$emit('click-overlay')">
    <div class="popup-content">
      <div class="popup-header">
        <span v-if="!!title" class="popup-title">{{ title }}</span>
        <i v-if="closeable" class="icon icon-close popup-icon" @click="$emit('click-close-icon')"></i>
      </div>
      <div class="popup-body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean, // 是否展示
    closeable: Boolean, // 是否显示关闭图标
    title: String // 标题
  },

  methods: {}
}
</script>
